import script from "./ImportTeresaStandard.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportTeresaStandard.vue?vue&type=script&setup=true&lang=js"

import "./ImportTeresaStandard.vue?vue&type=style&index=0&id=59e5e90d&lang=css"

const __exports__ = script;

export default __exports__